export default [
  'productId',
  'name',
  'description',
  'url',
  'tags1',
  'tags2',
  'tags3',
  'price',
  'priceCurrencyCode',
  'listPrice',
  'imageUrl',
  'alternateImageUrls',
  'datePublished',
  'categories',
  // 'performanceMetrics.productViews',
  'customFields.key',
  'customFields.value',
  // Variants
  'skus.name',
  'skus.id',
  // 'skus.available',
  'skus.imageUrl',
  'skus.price',
  // 'skus.listPrice',
  'skus.customFields.key',
  'skus.customFields.value',
];
